import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CommentIdsFromMarkerUploadQueryVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
}>;


export type CommentIdsFromMarkerUploadQuery = { __typename?: 'Query', commentIdsFromMarkerUpload: Array<string> };


export const CommentIdsFromMarkerUpload = /*#__PURE__*/ gql`
    query CommentIdsFromMarkerUpload($assetId: ID!) {
  commentIdsFromMarkerUpload(assetId: $assetId)
}
    ` as unknown as DocumentNode<CommentIdsFromMarkerUploadQuery, CommentIdsFromMarkerUploadQueryVariables>;

          

          export const useCommentIdsFromMarkerUploadQuery = (options?:QueryHookOptions<CommentIdsFromMarkerUploadQuery, CommentIdsFromMarkerUploadQueryVariables>) => useQuery(CommentIdsFromMarkerUpload, options);

          

          export type CommentIdsFromMarkerUploadQueryOptions = QueryHookOptions<CommentIdsFromMarkerUploadQuery, CommentIdsFromMarkerUploadQueryVariables>;

          

          export const useCommentIdsFromMarkerUploadLazyQuery = (options?:LazyQueryHookOptions<CommentIdsFromMarkerUploadQuery, CommentIdsFromMarkerUploadQueryVariables>) => useLazyQuery(CommentIdsFromMarkerUpload, options);

          

          export type CommentIdsFromMarkerUploadQueryResult = ReturnType<typeof useCommentIdsFromMarkerUploadQuery>;

          
